module.exports = __webpack_public_path__ + "img/strategy-grid.1005b497.svg";